import React, { Fragment } from 'react';
import { Dialog, Transition } from '@headlessui/react';
import { XIcon } from '@heroicons/react/outline';
import { IconType } from 'react-icons';

import SidebarContainer from './SidebarContainer';
import { RouteItem } from '@wajeez-web/core/types';
import { CommonActions, useCommonSelector } from '@wajeez-web/stores/common';
import { useAppDispatch } from '@wajeez-web/stores/base';

const SideBar = ({
  navigation: a,
  withSettings = true,
}: {
  navigation?: RouteItem[];
  withSettings?: boolean;
}) => {
  const { navCollapsed } = useCommonSelector((state) => state.common.settings);
  const navigation = useCommonSelector((state) => state.navigation.routes);

  const dispatch = useAppDispatch();

  return (
    <>
      <Transition.Root show={navCollapsed || false} as={Fragment}>
        <Dialog
          as="div"
          static
          className="fixed inset-0 flex z-40 md:hidden"
          open={navCollapsed}
          onClose={() => dispatch(CommonActions.setNavBarCollapsed(true))}
        >
          <Transition.Child
            as={Fragment}
            enter="transition-opacity ease-linear duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="transition-opacity ease-linear duration-300"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Dialog.Overlay className="fixed inset-0 bg-gray-600/75 " />
          </Transition.Child>
          <Transition.Child
            as={Fragment}
            enter="transition ease-in-out duration-300 transform"
            enterFrom="-translate-x-full"
            enterTo="translate-x-0"
            leave="transition ease-in-out duration-300 transform"
            leaveFrom="translate-x-0"
            leaveTo="-translate-x-full"
          >
            <div className="relative  flex flex-col  bg-gradient-to-b from-sidebar-bg-from to-sidebar-bg-to">
              <Transition.Child
                as={Fragment}
                enter="ease-in-out duration-300"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="ease-in-out duration-300"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
              >
                <div className={`absolute top-0 ltr:right-0 rtl:left-0`}>
                  <button
                    className="ms-1 flex items-center justify-center h-6 w-6 rounded-full focus:outline-none "
                    onClick={() =>
                      dispatch(CommonActions.setNavBarCollapsed(false))
                    }
                  >
                    <span className="sr-only">Close sidebar</span>
                    <XIcon
                      className="h-6 w-6 text-gray-400"
                      aria-hidden="true"
                    />
                  </button>
                </div>
              </Transition.Child>

              <div className=" py-1 ">
                <SidebarContainer
                  navigation={navigation}
                  withSettings={withSettings}
                />
              </div>
            </div>
          </Transition.Child>
        </Dialog>
      </Transition.Root>

      {/* Static sidebar for desktop */}
      <div className="hidden   md:block ">
        <SidebarContainer navigation={navigation} withSettings={withSettings} />
      </div>
    </>
  );
};

export default SideBar;
